const CertificateName: React.FC<{
	shortName: string
	nameTh: string
	nameEn: string
	colorLabel: string
}> = ({ shortName, nameTh, nameEn, colorLabel }) => {
	return (
		<div className="d-flex align-items-center justify-content-left" style={{ columnGap: '8px' }}>
			{/* <img alt="Logo" src={img} width={40} height={40} style={{ borderRadius: '50%' }} /> */}
			<div
				className="w-40px h-40px p-2 text-kumopack-base-white fw-bold d-flex align-items-center justify-content-center fs-8"
				style={{ borderRadius: '50%', backgroundColor: colorLabel }}>
				<div>{shortName ?? '-'}</div>
			</div>

			<div className="d-flex flex-column">
				<span className="text-kumopack-grey-800">{nameTh ?? '-'}</span>
				<span className="text-kumopack-grey-600">{nameEn ?? '-'}</span>
			</div>
		</div>
	)
}

export default CertificateName
